<div class="etiket2">
    <div class="card"
         style="background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.2)), url('{{envire.crmimages}}{{etiket.resimId}}'); margin: 0px;">
        <div class="card-category">{{etiket.name}}</div>
        <a class="card-link" href="#"></a>
    </div>
</div>
